import React, { Component } from "react";
import { DataTable } from "primereact/components/datatable/DataTable";
import { Column } from "primereact/components/column/Column";
//import { ProgressSpinner } from "primereact/components/progressspinner/ProgressSpinner";
import { Button } from "primereact/components/button/Button";
import { Growl } from "primereact/components/growl/Growl";
import { Dialog } from "primereact/components/dialog/Dialog";

//Imports from common
import { api } from "../../common/CloudService/ApiPromisify";
import { CloudService } from "../../common/CloudService/ClientLibsReference";
import { LoadScreen } from "../Common/LoadScreen";
//import { formatId } from "../../common/FormatId";

export class ClientBuildings extends Component {
  constructor() {
    super();
    this.state = {
      loaded: false,
      test: "",
      buildingList: [],
      buildingSelected: false,
      buildingEdited: false,
      buildingAdded: false,
      buildingDeleted: false,
      selectedBuilding: "",
      buildingClientId: "",
      buildingCodeTag: "",
      buildingId: "",
      buildingLastUpdatedDateTime: "",
      buildingSiteId: "",
      buildingUserId: "",
      buildingName: "",
      buildingAddressLine1: "",
      buildingAddressLine2: "",
      buildingPostcode: "",
      buildingTelephone: "",
      buildingTown: "",
      buildingEmail: "",
      editedBuildingName: "",
      editedBuildingAddressLine1: "",
      editedBuildingAddressLine2: "",
      editedBuildingPostcode: "",
      editedBuildingTown: "",
      editedBuildingEmail: "",
      editedBuildingTelephone: ""
    };
  }

  componentDidMount() {
    this.getBuildings();
  }

  getBuildings = async () => {
    this.setState({ loaded: false });

    let buildingRequest = new CloudService.BuildingRequest();
    buildingRequest.codeTag = localStorage.getItem("codeTag");
    buildingRequest.siteId = localStorage.getItem("siteId");

    await api("buildingApiV1BuildingGetBySiteId", buildingRequest).then(res => {
      let buildingResponse = CloudService.BuildingResponse.constructFromObject(
        res.data
      );
      console.log(buildingResponse);

      if (buildingResponse.errorCode === 0) {
        this.setState({
          buildingList: buildingResponse.buildingList
        });
      } else {
        this.growl.show({
          severity: "error",
          summary: "Error",
          detail:
            "An error occured retrieving data, please refresh and try again",
          life: 3000
        });
      }
    });

    this.setState({ loaded: true });
  };

  editBuilding = async () => {
    this.setState({ loaded: false });

    let buildingRequest = new CloudService.BuildingRequest();
    buildingRequest.codeTag = localStorage.getItem("codeTag");
    buildingRequest.userId = localStorage.getItem("userId");
    buildingRequest.id = this.state.buildingId;
    buildingRequest.lastUpdatedDateTime = this.state.buildingLastUpdatedDateTime;
    buildingRequest.name = this.state.editedBuildingName;
    buildingRequest.addressLine1 = this.state.editedBuildingAddressLine1;
    buildingRequest.addressLine2 = this.state.editedBuildingAddressLine2;
    buildingRequest.postcode = this.state.editedBuildingPostcode;
    buildingRequest.town = this.state.editedBuildingTown;
    buildingRequest.email = this.state.editedBuildingEmail;
    buildingRequest.telephone = this.state.editedBuildingTelephone;

    await api("buildingApiV1BuildingUpdate", buildingRequest).then(res => {
      let buildingResponse = CloudService.BuildingResponse.constructFromObject(
        res.data
      );
      console.log(buildingResponse);

      if (buildingResponse.errorCode === 0) {
        this.setState({
          buildingEdited: false
        });
        this.growl.show({
          severity: "success",
          summary: "Success",
          detail: "Building successfully updated",
          life: 3000
        });
        this.getBuildings();
      } else {
        this.setState({ loaded: true });
        this.growl.show({
          severity: "error",
          summary: "Error",
          detail: "An error occured updating the building, please try again",
          life: 3000
        });
      }
    });
  };

  addBuilding = async () => {
    this.setState({ loaded: false });

    let buildingRequest = new CloudService.BuildingRequest();
    buildingRequest.codeTag = localStorage.getItem("codeTag");
    buildingRequest.userId = localStorage.getItem("userId");
    buildingRequest.clientId = localStorage.getItem("clientId");
    buildingRequest.siteId = localStorage.getItem("siteId");
    buildingRequest.name = this.state.editedBuildingName;
    buildingRequest.addressLine1 = this.state.editedBuildingAddressLine1;
    buildingRequest.addressLine2 = this.state.editedBuildingAddressLine2;
    buildingRequest.postcode = this.state.editedBuildingPostcode;
    buildingRequest.town = this.state.editedBuildingTown;
    buildingRequest.email = this.state.editedBuildingEmail;
    buildingRequest.telephone = this.state.editedBuildingTelephone;

    await api("buildingApiV1BuildingCreate", buildingRequest).then(res => {
      let buildingResponse = CloudService.BuildingResponse.constructFromObject(
        res.data
      );
      console.log(buildingResponse);

      if (buildingResponse.errorCode === 0) {
        this.setState({
          buildingEdited: false,
          buildingAdded: false
        });
        this.growl.show({
          severity: "success",
          summary: "Success",
          detail: "Building successfully created",
          life: 3000
        });
        this.getBuildings();
      } else {
        this.setState({ loaded: true });
        this.growl.show({
          severity: "error",
          summary: "Error",
          detail: "An error occured creating the client, please try again",
          life: 3000
        });
      }
    });
  };

  deleteBuilding = async () => {
    this.setState({ loaded: false });

    let buildingRequest = new CloudService.BuildingRequest();
    buildingRequest.codeTag = localStorage.getItem("codeTag");
    buildingRequest.userId = localStorage.getItem("userId");
    buildingRequest.id = this.state.buildingId;
    buildingRequest.lastUpdatedDateTime = this.state.buildingLastUpdatedDateTime;

    await api("buildingApiV1BuildingDelete", buildingRequest).then(res => {
      let buildingResponse = CloudService.BuildingResponse.constructFromObject(
        res.data
      );
      console.log(buildingResponse);

      if (buildingResponse.errorCode === 0) {
        this.setState({
          buildingSelected: false
        });
        this.growl.show({
          severity: "success",
          summary: "Success",
          detail: "Building successfully deleted",
          life: 3000
        });
        this.getBuildings();
      } else {
        this.setState({ loaded: true });
        this.growl.show({
          severity: "error",
          summary: "Error",
          detail: "An error occured deleting the building, please try again",
          life: 3000
        });
      }
    });
  };

  render() {
    return (
      <div className="ui-g dashboard">
        <Growl style={{ textAlign: "left" }} ref={el => (this.growl = el)} />
        <Dialog
          header="Delete Building"
          footer={
            <div>
              <Button
                label="Yes"
                onClick={() => {
                  this.setState({ buildingDeleted: false });
                  this.deleteBuilding();
                }}
                style={{
                  float: "right",
                  color: "white",
                  backgroundColor: "#01a4ef"
                }}
              />
              <Button
                label="No"
                onClick={() => {
                  this.setState({ buildingDeleted: false });
                }}
                style={{
                  float: "right",
                  color: "white",
                  backgroundColor: "#808080"
                }}
              />
            </div>
          }
          visible={this.state.buildingDeleted}
          style={{ width: "50vw" }}
          modal={true}
          onHide={e => this.setState({ buildingDeleted: false })}
        >
          Are you sure you want to delete?
        </Dialog>
        {this.state.loaded === false ? (
          <LoadScreen />
        ) : (
          <div className="ui-g-12">
            {/*Buildings Card*/}
            {this.state.buildingSelected === false ? (
              <label />
            ) : (
              <div className="ui-g-12 card">
                <div className="ui-g-12">
                  {/*Empty div for spacing*/}
                  <label />
                </div>
                <div className="ui-g-12">
                  <div className="ui-g-4">
                    <b>Building Name: </b>
                    <label>{this.state.buildingName || "Not Set"}</label>
                  </div>
                  <div className="ui-g-4">
                    <b>Address Line 1: </b>
                    <label>
                      {this.state.buildingAddressLine1 || "Not Set"}
                    </label>
                  </div>
                  <div className="ui-g-4">
                    <b>Address Line 2: </b>
                    <label>
                      {this.state.buildingAddressLine2 || "Not Set"}
                    </label>
                  </div>
                </div>
                <div className="ui-g-12">
                  <div className="ui-g-4">
                    <b>Postcode: </b>
                    <label>{this.state.buildingPostcode || "Not Set"}</label>
                  </div>
                  <div className="ui-g-4">
                    <b>City: </b>
                    <label>{this.state.buildingTown || "Not Set"}</label>
                  </div>
                  <div className="ui-g-4">
                    <b>Email: </b>
                    <label>{this.state.buildingEmail || "Not Set"}</label>
                  </div>
                </div>
                <div className="ui-g-12">
                  <div className="ui-g-4">
                    <b>Contact Telephone: </b>
                    <label>{this.state.buildingTelephone || "Not Set"}</label>
                  </div>
                </div>
                <div className="ui-g-12">
                  <Button
                    label="Edit"
                    onClick={() => {
                      this.setState({
                        buildingSelected: false,
                        buildingEdited: true,
                        buildingAdded: false,
                        editedBuildingName: this.state.buildingName,
                        editedBuildingAddressLine1: this.state
                          .buildingAddressLine1,
                        editedBuildingAddressLine2: this.state
                          .buildingAddressLine2,
                        editedBuildingPostcode: this.state.buildingPostcode,
                        editedBuildingTown: this.state.buildingTown,
                        editedBuildingEmail: this.state.buildingEmail,
                        editedBuildingTelephone: this.state.buildingTelephone
                      });
                    }}
                    style={{ float: "right" }}
                  />
                  <Button
                    label="Delete"
                    onClick={() => {
                      this.setState({ buildingDeleted: true });
                    }}
                    style={{ float: "right" }}
                  />
                  <Button
                    className="secondary-btn"
                    label="View Locations"
                    onClick={() => {
                      localStorage.setItem("buildingId", this.state.buildingId);
                      window.location = "#/clientLocations";
                    }}
                    style={{ float: "right" }}
                  />
                </div>
              </div>
            )}

            {/*Editing Buildings Card*/}
            {this.state.buildingEdited === false ? (
              <label />
            ) : (
              <div className="ui-g-12 card">
                <div className="ui-g-12">
                  {/*Empty div for spacing*/}
                  <label />
                </div>
                <div className="ui-g-12">
                  <div className="ui-g-4">
                    <span className="md-inputfield form-field">
                      <input
                        className={
                          this.state.editedBuildingName === "" ||
                          this.state.editedBuildingName === undefined
                            ? "ui-inputtext"
                            : "ui-inputtext ui-state-filled"
                        }
                        type="text"
                        value={this.state.editedBuildingName || ""}
                        onChange={e =>
                          this.setState({
                            editedBuildingName: e.target.value
                          })
                        }
                      />
                      <label>Building Name *</label>
                    </span>
                  </div>
                  <div className="ui-g-4">
                    <span className="md-inputfield form-field">
                      <input
                        className={
                          this.state.editedBuildingAddressLine1 === "" ||
                          this.state.editedBuildingAddressLine1 === undefined
                            ? "ui-inputtext"
                            : "ui-inputtext ui-state-filled"
                        }
                        type="text"
                        value={this.state.editedBuildingAddressLine1 || ""}
                        onChange={e =>
                          this.setState({
                            editedBuildingAddressLine1: e.target.value
                          })
                        }
                      />
                      <label>Address Line 1</label>
                    </span>
                  </div>
                  <div className="ui-g-4">
                    <span className="md-inputfield form-field">
                      <input
                        className={
                          this.state.editedBuildingAddressLine2 === "" ||
                          this.state.editedBuildingAddressLine2 === undefined
                            ? "ui-inputtext"
                            : "ui-inputtext ui-state-filled"
                        }
                        type="text"
                        value={this.state.editedBuildingAddressLine2 || ""}
                        onChange={e =>
                          this.setState({
                            editedBuildingAddressLine2: e.target.value
                          })
                        }
                      />
                      <label>Address Line 2</label>
                    </span>
                  </div>
                </div>
                <div className="ui-g-12">
                  <div className="ui-g-4">
                    <span className="md-inputfield form-field">
                      <input
                        className={
                          this.state.editedBuildingPostcode === "" ||
                          this.state.editedBuildingPostcode === undefined
                            ? "ui-inputtext"
                            : "ui-inputtext ui-state-filled"
                        }
                        type="text"
                        value={this.state.editedBuildingPostcode || ""}
                        onChange={e =>
                          this.setState({
                            editedBuildingPostcode: e.target.value
                          })
                        }
                      />
                      <label>Postcode</label>
                    </span>
                  </div>
                  <div className="ui-g-4">
                    <span className="md-inputfield form-field">
                      <input
                        className={
                          this.state.editedBuildingTown === "" ||
                          this.state.editedBuildingTown === undefined
                            ? "ui-inputtext"
                            : "ui-inputtext ui-state-filled"
                        }
                        type="text"
                        value={this.state.editedBuildingTown || ""}
                        onChange={e =>
                          this.setState({ editedBuildingTown: e.target.value })
                        }
                      />
                      <label>City</label>
                    </span>
                  </div>
                  <div className="ui-g-4">
                    <span className="md-inputfield form-field">
                      <input
                        className={
                          this.state.editedBuildingEmail === "" ||
                          this.state.editedBuildingEmail === undefined
                            ? "ui-inputtext"
                            : "ui-inputtext ui-state-filled"
                        }
                        type="text"
                        value={this.state.editedBuildingEmail || ""}
                        onChange={e =>
                          this.setState({ editedBuildingEmail: e.target.value })
                        }
                      />
                      <label>Email</label>
                    </span>
                  </div>
                </div>
                <div className="ui-g-12">
                  <div className="ui-g-4">
                    <span className="md-inputfield form-field">
                      <input
                        className={
                          this.state.editedBuildingTelephone === "" ||
                          this.state.editedBuildingTelephone === undefined
                            ? "ui-inputtext"
                            : "ui-inputtext ui-state-filled"
                        }
                        type="text"
                        value={this.state.editedBuildingTelephone || ""}
                        onChange={e =>
                          this.setState({
                            editedBuildingTelephone: e.target.value
                          })
                        }
                      />
                      <label>Contact Telephone</label>
                    </span>
                  </div>
                </div>
                <div className="ui-g-12">
                  <Button
                    label="Save"
                    onClick={() => {
                      this.state.buildingAdded === true
                        ? this.addBuilding()
                        : this.editBuilding();
                    }}
                    style={{ float: "right" }}
                  />
                  <Button
                    label="Cancel"
                    onClick={() => {
                      this.state.buildingAdded === true
                        ? this.setState({
                            buildingSelected: false,
                            buildingEdited: false,
                            buildingAdded: false
                          })
                        : this.setState({
                            buildingSelected: true,
                            buildingEdited: false,
                            buildingAdded: false
                          });
                    }}
                    style={{ float: "right" }}
                  />
                </div>
              </div>
            )}

            {/*Buildings Table*/}
            <div className="ui-g-12 card">
              <DataTable
                value={this.state.buildingList}
                selectionMode="single"
                onSelectionChange={e => {
                  this.setState(
                    {
                      buildingSelected: true,
                      buildingEdited: false,
                      buildingAdded: false,
                      selectedBuilding: e.data,
                      buildingClientId: e.data.clientId,
                      buildingCodeTag: e.data.codeTag,
                      buildingId: e.data.id,
                      buildingLastUpdatedDateTime: e.data.lastUpdatedDateTime,
                      buildingSiteId: e.data.siteId,
                      buildingUserId: e.data.userId,
                      buildingName: e.data.name,
                      buildingAddressLine1: e.data.addressLine1,
                      buildingAddressLine2: e.data.addressLine2,
                      buildingPostcode: e.data.postcode,
                      buildingTelephone: e.data.telephone,
                      buildingTown: e.data.town,
                      buildingEmail: e.data.email
                    },
                    () => {
                      console.log(this.state.selectedBuilding);
                    }
                  );
                }}
                header="Buildings"
                autoLayout={true}
                paginator={true}
                alwaysShowPaginator={true}
                rows={10}
                emptyMessage="No Buildings"
              >
                <Column
                  field="name"
                  header="Building Name"
                  sortable={true}
                  filter={true}
                  style={{ overflow: "auto" }}
                />
                <Column
                  field="addressLine1"
                  header="Address Line 1"
                  sortable={true}
                  filter={true}
                  style={{ overflow: "auto" }}
                />
                <Column
                  field="addressLine2"
                  header="Address Line 2"
                  sortable={true}
                  filter={true}
                  style={{ overflow: "auto" }}
                />
                <Column
                  field="telephone"
                  header="Contact Telephone"
                  sortable={true}
                  filter={true}
                  style={{ overflow: "auto" }}
                />
                <Column
                  field="town"
                  header="City"
                  sortable={true}
                  filter={true}
                  style={{ overflow: "auto" }}
                />
                <Column
                  field="email"
                  header="Email"
                  sortable={true}
                  filter={true}
                  style={{ overflow: "auto" }}
                />
              </DataTable>
            </div>
            <div className="ui-g-12">
              <Button
                label="Create New"
                onClick={() => {
                  this.setState({
                    buildingSelected: false,
                    buildingEdited: true,
                    buildingAdded: true,
                    editedBuildingName: "",
                    editedBuildingAddressLine1: "",
                    editedBuildingAddressLine2: "",
                    editedBuildingPostcode: "",
                    editedBuildingTown: "",
                    editedBuildingEmail: "",
                    editedBuildingTelephone: ""
                  });
                }}
                style={{ float: "right" }}
              />
              <Button
                className="secondary-btn"
                label="Back"
                onClick={() => {
                  window.location = "#/clientSites";
                }}
                style={{ float: "right" }}
              />
            </div>
          </div>
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Clients/ClientBuildings.js